/* eslint 'jsx-a11y/alt-text': 'off','no-redeclare': 'off', 'array-callback-return': 'off', eqeqeq: 'off' */
import React, {Component} from "react";
import { Button, Label, FormGroup, Col, Modal, Table } from "reactstrap";
import AddWOEmployee from './AddWOEmployee';
import {connect} from "react-redux";
import EditIcon from '../../../../Assets/images/Icons__edit.svg';
import DeleteIcon from '../../../../Assets/images/Icons__trash2.svg';
import {Icon} from 'semantic-ui-react';
import { GetRegularExpresions } from '../../../../action/EmployeeAction';
import { PutTenantEmployeesDetailsAction, DeleteEmployees, IndividualTenantDetailGetCall } from '../../../../action/tenantAction';

let TenantUserID = 0, TenantID = 0, EmployeeList = [], ErrResetPwd=true, ErrResetConfirmPwd=true, isEdit = false, TenantName = "";

const ErrorSign = {
    color: '#D42D27',
    paddingLeft: '8px',
    paddingTop: '0px',
    paddingRight: '14px',
    width: '22px',
    height: '22px',
    top: '406px',
    left: '959px'
};

const PaddingContainer = {
    paddingLeft:'10px',
    paddingTop:'10px'
};

const ErrorPadding = {
    'color': '#D42D27',
    'font-family': 'Lato',
    'font-style': 'italic',
    'border': '2px solid #D42D27',
    'height': '40px',
    'padding': '10px',
    'float': 'left',
    'background-color': '#FFFFFF',
    'font-size': '13px',
    'margin-bottom': '0px'
};

class WOEmployeeList extends Component{
    constructor(props){
        super(props);
        this.state={
            employeemodal: false,
            resetmodal: false,
            deletemodal: false,
            error: false,
            isError: false,
            tenantDetails: [],
            userID:0,
            MismatchResetPwd:false,
            sort: {
                column:'logOnName',
                direction: [
                    { name: 'logOnName', direction: 'asc', onclick: true },
                    { name: 'firstName', direction: 'desc', onclick: false },
                    { name: 'lastName', direction: 'desc', onclick: false },
                    { name: 'employeeEmail', direction: 'desc', onclick: false}
                ]
            },
            IsModalClose: false,
            PassWordErrorMsg: "New password is required."
        };
        this.onSort = this.onSort.bind(this);
        this.onCloseResetModal = this.onCloseResetModal.bind(this);
        this.SaveResetPwd = this.SaveResetPwd.bind(this);
        this.DeletedEmployee = this.DeletedEmployee.bind(this);
        this.onCloseDeleteModal = this.onCloseDeleteModal.bind(this);
    }

    componentWillMount() {
        this.props.GetRegularExpresions();
        TenantID = this.props.TenantId;
        if (TenantID > 0) {
            this.props.IndividualTenantDetailGetCall(TenantID);
        }
    }

    componentWillReceiveProps(next){
        if(this.props.ModalOpenCloseResponse !== next.ModalOpenCloseResponse){
            if(next.ModalOpenCloseResponse.ModalOpenClose.modal_open === "close"){
                this.setState({employeemodal : false, IsModalClose: true});
            }
        }
    }

    AddEmployee(e){
        e.preventDefault();
        TenantUserID = 0;
        EmployeeList = [];
        isEdit = false;
        this.setState({employeemodal: true});
    }

    EditEmployee(el){
        TenantUserID = el.tenantUserId;
        EmployeeList = el;
        isEdit = true;
        this.setState({employeemodal: true});
    }

    DeleteEmployee(el){
        TenantName = el.firstName + ' ' + el.lastName;
        this.setState({deletemodal: true, userID: el.tenantUserId});
    }
    
    DeletedEmployee(){
        var Data = [];
        var Emp_id_to_be_deleted = {
            "tenantUserId": this.state.userID
        }
        Data.push(Emp_id_to_be_deleted);

        if (Data.length > 0) {           
            this.props.DeleteEmployees(Data, TenantID, false);
            this.onCloseDeleteModal();
        }       
        
    }

    onCloseDeleteModal(){
        this.setState({deletemodal: false});
    }

    onSort = (column) => (e) => {
        this.setState({IsModalClose:false});
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name == column);
        const direction = this.state.sort.column ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.props.getEmployeeDetails.tenantUser;
        var notequals = 0;
        if (data_from_state != null) {
            const sortedData = data_from_state.sort((a, b) => {
                let nameA = a[column].toLowerCase();
                let nameB = b[column].toLowerCase();

                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });

            if (selected[0].direction == 'asc' && notequals == 1) {
                sortedData.reverse();
            }

            if (selected[0].name == "logOnName") {
                SortData[0].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "logOnName") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "firstName") {
                SortData[1].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "firstName") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "lastName") {
                SortData[2].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "lastName") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            if (selected[0].name == "employeeEmail") {
                SortData[3].direction = direction;
                var array = this.state.sort.direction;
                array.map(x => (x.name !== "employeeEmail") ? x.onclick = false : x.onclick = true);
                this.setState({ SortData: array });
            }
            this.props.getEmployeeDetails.tenantUser = sortedData;
            this.setState({
                sort: { column, direction: SortData }
            });
        }
    };

    resetPwd(tenantUser){
        this.OnClearResetErrors();
        this.setState({resetmodal: true, tenantDetails: tenantUser });
    }    

    SaveResetPwd(){
        this.setState({MismatchResetPwd : false, error: false, isError: false, PassWordErrorMsg: "New password is required."});
        let {tenantDetails} = this.state;
        this.OnClearResetErrors();
        var RegExpPasswordPattern = this.props.getResponse.RegularExpression[1];
        var RegexpPasswordLength = this.props.getResponse.RegularExpression[0];
        var RegexpPasswordDuplicatePattern = /([a-z0-9])\1/i;
        var RegexpPasswordDuplicateAllowed = this.props.getResponse.RegularExpression[3];
        var RegexpPasswordLogOnNameForPasswordAllowed = this.props.getResponse.RegularExpression[2];
        var NewPwd = this.refs.new_pwd.value;
        var ConfirmPwd = this.refs.confirm_pwd.value;
        var isValidUser = true;
        var EmployeeDetails = [];
        //Null check, Invalid Pwd, Mismatch
        if(NewPwd == "" || ConfirmPwd == ""){
            isValidUser = false;
            ErrResetPwd = NewPwd !== "" ? true : false;
            ErrResetConfirmPwd = ConfirmPwd !== "" ? true : false;
            this.setState({error: true,isError: true});
        }
        if(NewPwd !== ""){
            if(!NewPwd.match(RegexpPasswordLength) || !NewPwd.match(RegExpPasswordPattern)){
                isValidUser = false;
                ErrResetPwd = false;
                this.setState({isError: true, PassWordErrorMsg: "Password you entered is invalid."});
            }
            else if(RegexpPasswordDuplicateAllowed === "False" && NewPwd.match(RegexpPasswordDuplicatePattern)){                      
                isValidUser = false;
                ErrResetPwd = false;
                this.setState({isError: true, PassWordErrorMsg: "Password Cannot Contain Repeating Characters"});                 
            }
            else if (RegexpPasswordLogOnNameForPasswordAllowed === "False") {
                var l_LogOnName = tenantDetails.logOnName;
                if (l_LogOnName !== "" && NewPwd.toLowerCase().indexOf(l_LogOnName.toLowerCase()) != -1) {
                    isValidUser = false;
                    ErrResetPwd = false;
                    this.setState({isError: true, PassWordErrorMsg: "Password Cannot Contain User ID"});
                }
            }
        }
        if(NewPwd !== "" && ConfirmPwd !== "" && NewPwd !== ConfirmPwd){
            isValidUser = false;
            ErrResetConfirmPwd = false;
            this.setState({MismatchResetPwd : true,isError: true});
        }
        if(isValidUser){
               EmployeeDetails.push({ TenantUserId: tenantDetails.tenantUserId, TenantId: tenantDetails.tenantId, FirstName: tenantDetails.firstName, LastName: tenantDetails.lastName, LogOnName: tenantDetails.logOnName, Password: NewPwd, IsActive: tenantDetails.isActive, EmployeeEmail: tenantDetails.employeeEmail, AllowTemperatureAdjustment: tenantDetails.allowTemperatureAdjustment, EmployeePreference:tenantDetails.employeePreference, ZoneIds: tenantDetails.zoneIds, PreferenceUnits : tenantDetails.preferenceUnits, IsTraneConnectUser:tenantDetails.isTraneConnectUser});
               this.props.PutTenantEmployeesDetailsAction(EmployeeDetails[0]);
               this.setState({IsModalClose:true});
               this.onCloseResetModal();
        }
    }

    OnClearResetErrors(){
        ErrResetPwd=true;
        ErrResetConfirmPwd=true;
    }

    onCloseResetModal(){
        this.setState({resetmodal: false, isError: false});
    }

    render(){
       let WOUser = null;
       let TenantUserDetails = this.props.getEmployeeDetails;
       let count = 0;
       if(TenantUserDetails.tenantUser !== null && TenantUserDetails.tenantUser !== undefined && TenantUserDetails.tenantUser.length > 0){
            let Data = TenantUserDetails.tenantUser;
            if(this.state.IsModalClose){
                var column = this.state.sort.column;
                var direction = this.state.sort.direction.filter(x => x.name === column)[0].direction;
                var notequals = 0;
                const sortedData = Data.sort((a, b) => {
                    let nameA = a[column].toLowerCase();
                    let nameB = b[column].toLowerCase();
    
                    if (nameA < nameB) {
                        notequals = 1;
                        return -1;
                    }
                    if (nameA > nameB) {
                        notequals = 1;
                        return 1;
                    }
                    if (nameA == nameB) {
                        return 0;
                    }
                    return 0;
                });
                if (direction == 'desc' && notequals == 1) {
                    sortedData.reverse();
                }
            }
            WOUser = Data.map(el => {
            if (!el.isDeleted){
                count = count+1;
                return <tr key = {el.tenantUserId}>
                        <td style={{'word-wrap':'break-word'}}>{el.logOnName}</td>
                        <td style={{'word-wrap':'break-word'}}>{el.firstName}</td>
                        <td style={{'word-wrap':'break-word'}}>{el.lastName}</td>
                        <td style={{'word-wrap':'break-word'}}>{el.employeeEmail}</td>
                        <td style={{'text-align':'right'}}>
                            <span className="link_cursorUnderline" style={{marginRight:'15px'}} onClick={() => this.resetPwd(el)} >Reset Password</span>
                            <img src={EditIcon} style={{width:'18px'}} className="link_cursor" onClick={() => this.EditEmployee(el)}/>
                            <img src={DeleteIcon}  style={{width:'18px', marginLeft:'3px', valign:'bottom' }}  className="link_cursor" onClick={() => this.DeleteEmployee(el)}/>
                        </td>
                    </tr>
                }   
           })
       }
       else{
            WOUser = <tr><td colSpan="5">{"No Records Found"}</td></tr>
       }
    
       if(count == 0){
            WOUser = <tr><td colSpan="5">{"No Records Found"}</td></tr>
       }

       let ResetPassword =  <div>
                                <p className="wo_employee_textFont" style={PaddingContainer}>Reset Employee Password
                                    <span className="wo_employee_closeIcon" onClick={this.onCloseResetModal}>X</span>
                                </p>
                                <div style={{ borderTop:'1px solid #FFFFFF'}}/>
                                <div className="passwordContainer">
                                    <FormGroup row>
                                        <Col sm={{size:2}}>
                                            <Label className="wo_employee_textFont" style={{fontSize:'15px',fontWeight:'200'}} >User ID</Label><br/>
                                            <Label className="wo_employee_textFont">{this.state.tenantDetails.logOnName} </Label>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col sm={{size:6}}>
                                            <Label className={(!ErrResetPwd) ? "errortext wo_employee_headerlabel" : "wo_employee_headerlabel"}>New Password*</Label>
                                            <input type="password" ref="new_pwd" className={(!ErrResetPwd) ? "errorhighlight wo_employee_fieldvalue" : "wo_employee_fieldvalue"} style={{width:'282px'}}/>
                                            <span hidden={ErrResetPwd}><Icon name='exclamation triangle' style={ErrorSign} />
                                                <Label className="wo_employee_errortext">{this.state.PassWordErrorMsg}</Label>
                                            </span>
                                        </Col>
                                        <Col sm={{size: 6}}>
                                            <Label className={(!ErrResetConfirmPwd) ? "errortext wo_employee_headerlabel" : "wo_employee_headerlabel"}>Confirm Password*</Label>
                                            <input type="password" ref="confirm_pwd" className={(!ErrResetConfirmPwd) ? "errorhighlight wo_employee_fieldvalue" : "wo_employee_fieldvalue"} style={{width:'282px'}}/>
                                            <span hidden={ErrResetConfirmPwd}><Icon name='exclamation triangle' style={ErrorSign} />
                                                {(this.state.MismatchResetPwd) ? <Label className="wo_employee_errortext">Confirmation password does not match new password.</Label> : <Label className="wo_employee_errortext">Confirmation password is required.</Label>} 
                                            </span>
                                        </Col>
                                    </FormGroup>
                                </div>
                                <div style={{ borderTop:'1px solid #FFFFFF'}}/>
                                <div style={{marginTop:'10px', marginBottom:'25px'}}>
                                    <span className="workorderlbl-noentry" style={{paddingLeft:'10px'}}>*required fields </span> 
                                    <div style={{float:'right'}}>
                                        {(this.state.isError) ? <p style={ErrorPadding} ><Icon name='exclamation triangle' style={ErrorSign} /><b>Please correct all errors before continuing.</b></p> : ""}
                                        <Button className="wo_cancel_btn" style={{'float': 'right', 'margin-left': '6px','margin-top':'3px','margin-right':'10px'}} onClick={this.onCloseResetModal}>CANCEL</Button>
                                        <Button className="wo_save_btn" style={{'float': 'right', 'margin-left': '6px','margin-top':'3px'}} onClick={this.SaveResetPwd}>SAVE</Button>
                                    </div>
                                </div>
                           </div>
        
        let DeleteEmployee =    <div>
                                    <p className="wo_employee_textFont" style={PaddingContainer}>Delete Tenant Employee
                                        <span className="wo_employee_closeIcon" onClick={this.onCloseDeleteModal}>X</span>
                                    </p>
                                    <div style={{ borderTop:'1px solid #FFFFFF'}}/>
                                    <div className="deleteContainer">
                                        <p className="wo_employee_deleteText">Are you sure you want to permanently delete tenant employee: {TenantName}?</p>
                                    </div>
                                    <div style={{ borderTop:'1px solid #FFFFFF'}}/>
                                    <div style={{marginTop:'10px'}}>
                                        <Button className="wo_cancel_btn" style={{'float': 'right', margin: '0px 10px 6px 10px'}} onClick={this.onCloseDeleteModal}>CANCEL</Button>
                                        <Button className="wo_save_btn btn-black" style={{'float': 'right'}} onClick={this.DeletedEmployee}>DELETE</Button>
                                    </div>
                                </div>
        return(
            <div>
                <div>
                    <Label className="wo_employee_textFont">Employees</Label>
                    <Button className="btn-success" style={{ marginRight:'30px'}} onClick={(e) => {this.AddEmployee(e)}}>ADD NEW EMPLOYEE</Button>
                </div>
               <div className="table_container table_border" style={{marginLeft:'0px', marginRight:'30px', marginTop:'10px'}}>
                    <Table striped responsive className="Custom_table" style={{'table-layout':'fixed'}}>
                        <tbody  className="cell_container">
                            <tr>
                                <th onClick={this.onSort('logOnName')} className="wo_cursor">
                                    <span>USER ID</span>
                                    <span className={(this.state.sort.direction[0].name == "logOnName") ?
                                        (this.state.sort.direction[0].onclick) ? (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                        : (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th onClick={this.onSort('firstName')} className="wo_cursor">
                                    <span>FIRST NAME</span>
                                    <span className={(this.state.sort.direction[1].name == "firstName") ?
                                        (this.state.sort.direction[1].onclick) ? (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                        : (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th onClick={this.onSort('lastName')} className="wo_cursor">
                                    <span>LAST NAME</span>
                                    <span className={(this.state.sort.direction[2].name == "lastName") ?
                                        (this.state.sort.direction[2].onclick) ? (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                        : (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th  onClick={this.onSort('employeeEmail')} className="wo_cursor">
                                    <span>EMAIL</span>
                                    <span className={(this.state.sort.direction[3].name == "employeeEmail") ?
                                        (this.state.sort.direction[3].onclick) ? (this.state.sort.direction[3].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                        : (this.state.sort.direction[3].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                    </span>
                                </th>
                                <th></th>
                            </tr>
                            {WOUser}
                        </tbody>
                    </Table>
                </div>
                <Modal isOpen={this.state.employeemodal} contentClassName="modalContainer">
                    <AddWOEmployee  parentToChildData={[TenantUserID, TenantID, EmployeeList, isEdit]}/>
                </Modal>
                <Modal isOpen={this.state.resetmodal} contentClassName="resetContainer">
                    {ResetPassword}
                </Modal>
                <Modal isOpen={this.state.deletemodal} contentClassName="resetContainer">
                    {DeleteEmployee}
                </Modal>
            </div>
        )
    }
};

const mapStateToProps = state => {
    return {
        getEmployeeDetails: state.ViewtenantsRootReducer.TenantDetails,
        ModalOpenCloseResponse: state.ModalOpenCloseRootReducer,
        getResponse: state.EmployeeRootReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetRegularExpresions: () => dispatch(GetRegularExpresions()),
        IndividualTenantDetailGetCall: (id) => dispatch(IndividualTenantDetailGetCall(id)),
        PutTenantEmployeesDetailsAction: (data) => dispatch(PutTenantEmployeesDetailsAction(data)),
        DeleteEmployees: (data, id, IsDeleteFutReq) => dispatch(DeleteEmployees(data, id, IsDeleteFutReq))
    };
};

export default connect(mapStateToProps,mapDispatchToProps)(WOEmployeeList);